import React, { useEffect, useState } from 'react';

import { Row, Col } from 'reactstrap';
import { faPencilAlt, faTruck, faCheck, faFile } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import Stepper from '../../../components/Stepper/Stepper';
import FichaTransportadorContainer from './components/FichaTransportadorContainer';
import IdentificacaoTransportador from './components/IdentificacaoTransportador';
import Veiculos from './components/Veiculos';

//API
import transportador_api from '../../../api/transportador_api';
import documento_api from '../../../api/documento_api';

//Helpers
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from 'context/auth';

//Shared
import Documentos from '../../../views/Shared/Documentos';

// estado inicial para o transportador
function initialStateTransportador() {
    return {
        fantasia: "",
        razao: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        cnpj: "",
        inscricao: "",
        responsavel: "",
        email: "",
        fone: "",
        celular: "",
        cep: "",
        credenciamentoNumero: "",
        credenciamentoValidade: "",
        operacaoNumero: "",
        operacaoValidade: "",
        numeroProcesso: "",
        divulgarInternet: "Sim",
        situacao: "Ativo",
        pluginMelhorRota: false,
        pluginNavegacao: false,
        dadosDefaultColetor: false,
        naoRealizaColetaAvulso: false,
        realizaColetaApenasBalanca: false,
        bloquearExclusaoColetaApp: false,
        realizaColetaPorQRCode: false,
        veiculos: [],
        documentos: []
    }
}
export default function NovoTransportador({ transportadorParam = {}, btnVoltar }) {
    const { setLoading } = useAuth();
    // estado para abrir ou fechar o formulario de cadastro/edição do veiculo
    const [openVeiculo, setOpenVeiculo] = useState(false);
    // estado para controle da exibição dos steps na tela
    const [activeStep, setActiveStep] = useState(1);
    // estado para exibição dos campos do transportador no formulario para edição ou criação de novo transportador
    const [transportador, setTransportador] = useState(Object.keys(transportadorParam).length == 0 ? initialStateTransportador : transportadorParam);
    //Estado para pegar os documentos para transportador 
    const [listdocumentos, setListDocumentos] = useState([]);
    //Estado para pegar erros
    const [errors, setErrors] = useState({})
    //campos para validação
    const camposTransportador = [
        objCampo({ name: "cnpj", required: true, cnpj: true }),
        objCampo({ name: "responsavel", required: true }),
        objCampo({ name: "email", required: true, email: true }),
        objCampo({ name: "fone", required: true }),
        objCampo({ name: "fantasia", required: true }),
        objCampo({ name: "razao", required: true }),
        objCampo({ name: "numeroProcesso", required: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "uf", required: false }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "numero", required: true }),
        objCampo({ name: "credenciamentoValidade", required: true, date: true }),
        objCampo({ name: "operacaoValidade", required: true, date: true }),
    ];

    //função que valida os campos que faltam ser preenchidos
    const validarDadosTransportador = () => {
        const errosTransportador = validarCampos(transportador, camposTransportador);
        const objetoDeErros = errosTransportador[0];
        if (errosTransportador[1].length > 0) {
            setErrors(objetoDeErros);
        }
        return errosTransportador[1]
    }

    //validações dos veiculos do transportado
    const validarVeiculos = () => {
        if (transportador.veiculos.length == 0) {
            showMessage("Aviso", "Informe pelo menos um veículo para cadastrar um transportador", "warning", null);
            return ["Informe ao menos um veiculo para este transportador"];
        }
        return null
    }

    function onChangeDocumentos(documento) {
        const _transportador = { ...transportador };
        const existeDocumento = _transportador.documentos.findIndex(x => x.tbDocumentos_Id === documento.tbDocumentos_Id);

        if (existeDocumento === -1) {
            _transportador.documentos = [..._transportador.documentos, {
                ...documento,
                tbTransportador_Id: transportador.id ? transportador.id : null
            }];
        } else {
            _transportador.documentos[existeDocumento] = {
                ..._transportador.documentos[existeDocumento],
                ...documento
            };
        }
        setTransportador(_transportador);
    }

    const validarDocumentos = () => {
        const documentosObrigatorios = listdocumentos.filter(doc => doc.obrigatorio);
        const todosDocumentosPresentes = documentosObrigatorios.every(obrigatorioDoc =>
            transportador?.documentos?.some(doc => doc.tbDocumentos_Id === obrigatorioDoc.id)
        );
        if (documentosObrigatorios.length > 0 && !todosDocumentosPresentes) {
            showMessage("Aviso", "Existe documento obrigatório que precisa ser informado", "warning", null);
            return ["Informe todos os documentos obrigatórios para este transportador!"];
        }
        return null;
    };

    // passos do cadastro de transportadores
    const steps = [
        { text: "Identificação do transportador", icon: faPencilAlt, validateStep: validarDadosTransportador },
        { text: "Veículos", icon: faTruck, validateStep: validarVeiculos, btnAdicionar: () => setOpenVeiculo(!openVeiculo) },
        { text: "Documentos", icon: faFile, validateStep: validarDocumentos },
        { text: "Finalizar", icon: faCheck }
    ];

    function loadDocumentos() {
        setLoading(true);
        documento_api.GetListDocumentosCategoria("Transportador").then(response => {
            if (response.data?.length === 0) {
                const index = steps.findIndex(step => step.text === "Documentos");
                if (index !== -1)
                    steps.splice(index, 1);
            } else {
                const _documentos = response.data.map(value => ({
                    id: value.id,
                    identificacao: value.identificacao,
                    descricao: value.descricao,
                    obrigatorio: value.cadastroTransportador === "Obrigatório"
                }));

                setListDocumentos(_documentos);
            }
        }).catch(e => showMessage("Aviso", e.message, "error"))
            .finally(f => setLoading(false));
    }

    // função para pegar o passo ativo dos passos disponiveis
    function getSteps() {
        switch (steps[activeStep - 1].text) {
            case "Identificação do transportador": {
                return <IdentificacaoTransportador
                    transportador={transportador}
                    setTransportador={setTransportador}
                    setErrors={setErrors}
                    errors={errors}
                    campos={[...camposTransportador]}
                />
            }
            case "Veículos": {
                return (
                    <Veiculos
                        transportador={transportador}
                        setTransportador={setTransportador}
                        validarCampos={validarCampos}
                        errors={errors}
                        setErrors={setErrors}
                        openForm={openVeiculo}
                        setOpenForm={setOpenVeiculo}
                    />
                )
            }
            case "Documentos": {
                return (
                    <Documentos
                        documentos={listdocumentos}
                        onChangeDocumentos={onChangeDocumentos}
                        state={transportador}
                    />
                )
            }
            case "Finalizar": {
                return (
                    <div>
                        <p className='ms-4 mb-3'>Confira se todos os dados estão corretos</p>
                        <FichaTransportadorContainer
                            transportador={transportador}
                            veiculos={transportador.veiculos}
                            editTransportador={() => setActiveStep(1)}
                            editVeiculos={() => setActiveStep(2)}
                        />
                    </div>
                )
            }
            default: {
                return (
                    <div>
                        Passo não encontrado!
                    </div>
                )
            }
        }
    }

    //Envio dos dados para serem cadastrados pela api no banco
    async function onSubmit() {
        const _transportador = { ...transportador };
        _transportador.veiculos = transportador.veiculos.map(veiculo => ({
            ...veiculo,
            tara: veiculo.tara.toString().replace(",", "."),
            capacidade: veiculo.capacidade.toString().replace(",", ".")
        }));
    
        let _documentos = [...transportador.documentos];
        delete _transportador.documentos;
    
        setLoading(true);
    
        try {
            let res;
            if (!_transportador.id) {
                res = await transportador_api.Post(_transportador);
                _documentos = _documentos.map(doc => ({
                    ...doc,
                    tbTransportador_Id: res.data.id
                }));
    
                await transportador_api.PostDocumentos(_documentos);
                showMessage("Sucesso", "Transportador cadastrado com sucesso", "success", btnVoltar);
    
            } else {
                res = await transportador_api.Put(_transportador);
                _documentos = _documentos.map(doc => ({
                    ...doc,
                    tbTransportador_Id: res.data.id
                }));
    
                await transportador_api.PostDocumentos(_documentos);
                showMessage("Sucesso", "Transportador editado com sucesso", "success", btnVoltar);
            }
    
        } catch (error) {
            const message = error.message ? error.message || "Erro ao conectar com API" : "Erro ao conectar com API";
            showMessage("Erro", message, "error");
        } finally {
            setLoading(false);
        }
    }
    
    useEffect(() => {
        loadDocumentos();
    }, [])

    return (
        <>
            <MainCard btnVoltar={btnVoltar}>
                <Row className='mb-4'>
                    <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                </Row>
                <Stepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} onSubmit={onSubmit}>
                    {getSteps()}
                </Stepper>
            </MainCard>
        </>
    )
}